import React, { useContext } from "react";
import "./highlights.scss";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import { highlightsSection } from "../../portfolio";

export default function Highlights() {
  const { isDark } = useContext(StyleContext);

  if (!highlightsSection.display) return null;

  return (
    <div className={isDark ? "dark-mode main" : "main"} id="highlights">
      <Fade bottom duration={1000}>
        <h1 className="highlights-title">{highlightsSection.title}</h1>
        <p className="subTitle">{highlightsSection.subtitle}</p>

        <ul className="highlights-list">
          {highlightsSection.highlights.map((item, i) => (
            <li key={i} className="highlights-item">
              {item}
            </li>
          ))}
        </ul>
      </Fade>
    </div>
  );
}
